import { Col, Container, Image, Modal, Row } from 'react-bootstrap';
import { JobMember } from '@th-types/job.detail.type';

interface Props {
  members: JobMember[];
  handleClose: () => void;
}

export default function ModalJobMembers({ members, handleClose }: Props) {
  return (
    <Modal centered show onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title className="fw-bold fs-5">Job Team Members</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          {members.map((member) => {
            return (
              <Row key={member.id} className="mb-1">
                <Col md={2}>
                  <Image width={50} height={50} src={member.profileImageUrl} />
                </Col>
                <Col>
                  <div className="job-member my-1">
                    <div className="fw-bold name">{`${member.firstName} ${member.lastName}`}</div>
                    <div className="email">{member.email}</div>
                  </div>
                </Col>
              </Row>
            );
          })}
        </Container>
      </Modal.Body>
    </Modal>
  );
}
